module.exports = __webpack_public_path__ + "img/soccerboard130.87bf6ebe.jpg";